<!-- DeleteActivityGeneralForm.vue -->
<!-- Modal de confirmação de exclusão de uma atividade geral.               -->
<!-- Baseado em DeleteActivityForm.vue; usa useActivityGeneralStore.         -->
<script setup>
import { computed } from "vue";
import { useActivityGeneralStore } from "@/stores/useActivityGeneralStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  // ✅ objeto act completo, como usado em ActivityGeneralForm.vue
  activity: { type: Object, required: true },
});

const emit  = defineEmits(["close", "refresh", "notify"]);
const store = useActivityGeneralStore();

// ── título para a mensagem de confirmação ────────────────────────────────────
const activityTitle = computed(() =>
  store.selectedActivity?.activityTitle ??
  store.selectedActivity?.title         ??
  props.activity?.activityTitle         ??
  props.activity?.title                 ??
  ""
);

const messageTitle = computed(() => {
  const title = activityTitle.value?.trim();
  if (!title) return "Tem certeza que deseja apagar esta atividade?";
  return `Tem certeza que deseja apagar a atividade "${title}"?`;
});

// ── handler de confirmação ───────────────────────────────────────────────────
async function onConfirmDelete() {
  try {
    await store.deleteActivityById(props.activity.activityId);

    emit("notify", { type: "success", message: "Atividade apagada com sucesso." });
    emit("refresh");
    emit("close");
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Ocorreu um erro ao excluir a atividade.";

    emit("notify", { type: "error", message: msg });
    // relança para que DeleteConfirmModal pare o loading
    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Atividade"
    :messageTitle="messageTitle"
    messageSubtitle="Ao apagá-la serão excluídas também todas as Notas vinculadas a ela. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>